import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
  import {Chart} from 'chart.js';
  import {Router} from '@angular/router';
  import {Store} from '@ngrx/store';
  import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
  import {DoctorService} from '../../../../services/doctor.service';
  import {MatDialog} from '@angular/material/dialog';
  import {Observable, Subscription} from 'rxjs';
  import {MatTableDataSource} from '@angular/material/table';
  import {Patient} from '../../../../model/user/Patient';
  import {MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent} from '@angular/material/paginator';
  import {MatCheckboxChange} from '@angular/material/checkbox';
  import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-bar-chart-inactive-malattia-iniziale',
  templateUrl: './bar-chart-inactive-malattia-iniziale.component.html',
  styleUrls: ['./bar-chart-inactive-malattia-iniziale.component.css']
})
export class BarChartInactiveMalattiaInizialeComponent implements OnInit {

          // per inizializzazione
          getAuthState: Observable<any>;
          getDoctorState: Observable<any>;
          isAuthenticated: boolean;
          user = null;
          errorMessage = null;
          subscription1: Subscription;
          subscription2: Subscription;
          subscription3: Subscription;
          subscription5: Subscription;
          // elementi che servono per il bar-chart
          canvas: any;
          ctx: any;
          myChartInactivePatients: Chart;
          title = "Malattia iniziale attiva";
          destination = 'inactive';
          // ******************************************************************************************************************
          
          // ******************************************************************************************************************
          // seguenti righe: inizializzazione dei pazienti 
          // ******************************************************************************************************************
          inactiveGlobalMalattiaAttiva = 0;
          inactiveGlobalMalattiaInattiva = 0;
          activeGlobalMalattiaAttiva = 0;
          activeGlobalMalattiaInattiva = 0;
          malattiaAttivaGlobalPatients = 0;
          malattiaInattivaGlobalPatients = 0;
          inactiveGlobalPatientsArray = [];
          activeGlobalPatientsArray = [];
          inactivePatientsGlobal = [];
          // ******************************************************************************************************************
          // bar chart dei pazienti 
          // ******************************************************************************************************************
          public barChartLabelsGlobalInactive = ['Malattia iniziale INATTIVA', 'Malattia iniziale ATTIVA'];
          public barChartTypeGlobalInactive = 'horizontalBar';
          public barChartLegendGlobalInactive = true;
          public barChartDataGlobalInactive = [
            {
              data: this.activeGlobalPatientsArray, label: 'Attivo', backgroundColor: ['teal', 'teal'],
              hoverBackgroundColor: ['#066', '#066'],maxBarPercentage : 0.5,  // number (pixels) or 'flex'
            },
            {
              data: this.inactiveGlobalPatientsArray, label: 'Inattivo', backgroundColor: ['orangered','orangered'],
              hoverBackgroundColor: ['#cc3700', '#cc3700'], maxBarPercentage: 0.5,  // number (pixels) or 'flex'
            }];
          // paginator Inactive
          public pageSizeInactive = 5;
          public currentPageInactive = 0;
          public tasksInactive: any[];
          public totalSizeInactive = 0;
          // selezione Inactive Patients Global
          selectedInactive = false;
          patientInactiveMail: string[] = [];
          checkedInactive = false;
          // hover variables of Inactive
          isActiveInactiveHovered = false;
          @ViewChild(MatPaginator, {static: false}) set matPaginator(paginator: MatPaginator) {
            if (paginator) {
              paginator._intl.itemsPerPageLabel = 'Pazienti per pagina';
              paginator._intl.previousPageLabel = 'Pagina precedente';
              paginator._intl.nextPageLabel = 'Pagina successiva';
            }
          }
          // constructor
          constructor(private store: Store<AppState>,
                      private doctorService: DoctorService,
                      private snackBar: MatSnackBar) {
            this.getAuthState = this.store.select(selectAuthState);
            this.getDoctorState = this.store.select(selectDoctorState);
          }
          // ******************************************************************************************************************
          // metodo all'inizio
          ngOnInit(): void {
            this.subscription5 = this.getAuthState.subscribe((state) => {
              this.isAuthenticated = state.isAuthenticated;
              this.user = JSON.parse(localStorage.getItem('user'));
              this.errorMessage = state.errorMessage;
              this.retrieveGlobalInactiveMalattiaInattiva();
            });
          }
          ngOnDestroy(): void {
            this.subscription1.unsubscribe();
            this.subscription2.unsubscribe();
            this.subscription3.unsubscribe();
            this.subscription5.unsubscribe();
          }
          // ******************************************************************************************************************
          // metodi che si richiamano in cascata e prendono tutti gli inattivi in telemedicina
          // e in standard e poi tutti
          // i pazienti in ogni categoria per poter calcolare gli attivi
          // retrieve global active and inactive patients (le funzioni si richiamano in cascata) bar chart
          retrieveGlobalInactiveMalattiaInattiva() {
            this.subscription1 = this.doctorService.getInactiveMalattiaInattivaInizialeHBISCCAINumber().subscribe(npatients => {    
              this.inactiveGlobalMalattiaInattiva = parseInt(npatients.toString());
              this.inactiveGlobalPatientsArray.push(this.inactiveGlobalMalattiaInattiva); // riempio vettore del bar-chart con telemedicina
              this.retrieveGlobalInactiveMalattiaAttiva();
            }, error => {
              if (error.status === 500) {
                localStorage.setItem('expirationTime', '0');
                console.log('SESSIONE SCADUTA');
                location.reload();
              }
            });
          }
          retrieveGlobalInactiveMalattiaAttiva() {
            this.subscription2 = this.doctorService.getInactiveMalattiaAttivaInizialeHBISCCAINumber().subscribe(npatients => {
              this.inactiveGlobalMalattiaAttiva = parseInt(npatients.toString());
              this.inactiveGlobalPatientsArray.push(this.inactiveGlobalMalattiaAttiva); // riempio il vettore del bar chart con standard
              this.retrieveGlobalMalattiaAttivaNumber();
            }, error => {
              if (error.status === 500) {
                localStorage.setItem('expirationTime', '0');
                console.log('SESSIONE SCADUTA');
                location.reload();
              }
            });
          }
        
          retrieveGlobalMalattiaAttivaNumber() {
            this.subscription3 = this.doctorService.getGlobalMalattiaInizialeHBISCCAILoginExistsNumber().subscribe(num => {
              this.malattiaInattivaGlobalPatients = num[0];
              this.malattiaAttivaGlobalPatients = num[1];
              this.activeGlobalMalattiaInattiva = this.malattiaInattivaGlobalPatients - this.inactiveGlobalMalattiaInattiva;
              this.activeGlobalPatientsArray.push(this.activeGlobalMalattiaInattiva); // riempio il vettore del bar chart con telemedicina
              this.activeGlobalMalattiaAttiva = this.malattiaAttivaGlobalPatients - this.inactiveGlobalMalattiaAttiva;
              this.activeGlobalPatientsArray.push(this.activeGlobalMalattiaAttiva); // riempio il vettore del bar chart con standard
              this.canvasSetting();
            }, error => {
              if (error.status === 500) {
                localStorage.setItem('expirationTime', '0');
                console.log('SESSIONE SCADUTA');
                location.reload();
              }
            });
          }
         
          canvasSetting() {
              this.canvas = document.getElementById('myChartInactiveMalattiaIniziale') as HTMLCanvasElement;
              this.ctx = this.canvas.getContext('2d');
              this.myChartInactivePatients = new Chart(this.ctx, {
                type: this.barChartTypeGlobalInactive,
                data: {
                  labels: this.barChartLabelsGlobalInactive,
                  datasets: this.barChartDataGlobalInactive,
                },
                options: {
                  maintainAspectRatio: true,
                  responsive: true,
                  scales: {
                    xAxes: [{
                      display: true,
                      stacked: false,
                      ticks: {
                        fontSize: 12,
                        fontStyle: 'bold',
                        fontFamily: 'Helvetica',
                        fontColor: '#006192'
                      }
                    }],
                    yAxes: [{
                      display: true,
                      stacked: false,
                      ticks: {
                        fontSize: 12,
                        fontStyle: 'bold',
                        fontFamily: 'Helvetica',
                        fontColor: '#006192'
                      }
                    }],
                  },
                  legend: {
                    display: true,
                    position: 'top',
                    labels: {
                      usePointStyle: true,
                      fontColor: '#006192',
                      fontSize: 18,
                      fontFamily: 'Helvetica',
                    }
                  },
                  tooltips: {
                    // content: '{pathology}: {number}',
                    backgroundColor: '#1c1c1c',
                    bodyFontSize: 18,
                    titleFontSize: 18,
                    cornerRadius: 5,
                    caretPadding: 10
                  },
                  title: {
                    display: true,
                    text: "N° di utenti attivi/inattivi - HBI/SCCAI",
                    fontColor: '#006192',
                    fontSize: 20,
                    fontFamily: 'Helvetica',
                  },
                  hover: {
                    mode: 'nearest',
                    intersect: true
                  }
                }
              });
              } // dopo aver ottenuto tutti i dati creo il bar chart
            }